import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Box, IconButton, Tooltip, Chip } from '@mui/material'; // Removed Paper
import HandymanIcon from '@mui/icons-material/Handyman';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'; // Transfer icon
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import { DeviceTransferModal } from '../../devices';
import GlassCard from '../../../ui/glass/components/GlassCard';

const DefinedDevicesCard = ({ devices, customerId }) => {
    const [isTransferModalOpen, setIsTransferModalOpen] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState(null);

    const handleOpenTransfer = (device) => {
        setSelectedDevice(device);
        setIsTransferModalOpen(true);
    };

    return (
        <GlassCard sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h6">Tanımlı Cihazlar ({devices.length})</Typography>
            </Box>
            <Divider sx={{ mb: 2 }} />

            {devices.length > 0 ? (
                <GlassCard sx={{ p: 0, overflow: 'hidden' }}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ bgcolor: 'rgba(255,255,255,0.05)' }}>
                                    <TableCell><strong>Seri No</strong></TableCell>
                                    <TableCell><strong>Marka</strong></TableCell>
                                    <TableCell><strong>Model</strong></TableCell>
                                    <TableCell><strong>Sınıf</strong></TableCell>
                                    <TableCell><strong>Ekleme Tarihi</strong></TableCell>
                                    <TableCell align="right"><strong>İşlemler</strong></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {devices.map((device) => (
                                    <TableRow key={device.id} hover sx={{ transition: 'background-color 0.2s' }}>
                                        <TableCell sx={{ fontFamily: 'monospace' }}>
                                            {device.seriNumarasi}
                                            {device.isSgk && (
                                                <Chip
                                                    label="SGK"
                                                    color="warning"
                                                    size="small"
                                                    sx={{ ml: 1, height: 20, fontSize: '0.7rem' }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell>{device.marka}</TableCell>
                                        <TableCell>{device.model}</TableCell>
                                        <TableCell>{device.cihazSinifi || '-'}</TableCell>
                                        <TableCell>
                                            {device.eklenmeTarihi?.toDate
                                                ? format(device.eklenmeTarihi.toDate(), 'dd MMM yyyy', { locale: tr })
                                                : (device.createdAt?.toDate ? format(device.createdAt.toDate(), 'dd MMM yyyy', { locale: tr }) : '-')}
                                        </TableCell>
                                        <TableCell align="right">
                                            <Tooltip title="Başka Müşteriye Devret">
                                                <IconButton
                                                    size="small"
                                                    color="warning"
                                                    onClick={() => handleOpenTransfer(device)}
                                                    sx={{ mr: 1 }}
                                                >
                                                    <SwapHorizIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Button
                                                component={RouterLink}
                                                to={`/cihaz/${device.id}`}
                                                size="small"
                                                endIcon={<ArrowForwardIcon />}
                                            >
                                                Detay
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </GlassCard>
            ) : (
                <Typography color="text.secondary" sx={{ p: 2, textAlign: 'center' }}>
                    Bu müşteriye ait tanımlı cihaz bulunmamaktadır.
                </Typography>
            )}

            {/* Transfer Modal */}
            <DeviceTransferModal
                isOpen={isTransferModalOpen}
                onClose={() => setIsTransferModalOpen(false)}
                device={selectedDevice}
                currentCustomerId={customerId}
                onTransferSuccess={() => {
                    // Cihaz listeden otomatik düşecek (Firestore listener)
                    setIsTransferModalOpen(false);
                }}
            />
        </GlassCard>
    );
};

export default DefinedDevicesCard;
